// Serviço de Configurações do Usuário
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

// Obter token do localStorage
const getToken = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return user.token;
};

// Configurar headers com token
const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

// ==================== CONFIGURAÇÕES GERAIS ====================

export const getAllSettings = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/settings`, getConfig());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSettings = async (category) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/settings/${category}`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSettings = async (category, updates) => {
  try {
    const url = category
      ? `${API_URL}/api/settings/${category}`
      : `${API_URL}/api/settings`;
    const response = await axios.put(url, updates, getConfig());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resetSettings = async (category = null) => {
  try {
    const url = category
      ? `${API_URL}/api/settings/${category}`
      : `${API_URL}/api/settings`;
    const response = await axios.delete(url, getConfig());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== NOTIFICAÇÕES ====================

export const updateNotificationSettings = async (type, channel, setting, value) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/notifications/update`,
      { type, channel, setting, value },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== PRIVACIDADE ====================

export const updatePrivacySettings = async (updates) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/privacy/update`,
      updates,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const requestDataDownload = async () => {
  try {
    const response = await axios.post(
      `${API_URL}/api/settings/privacy/data-download`,
      {},
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== APARÊNCIA ====================

export const updateAppearanceSettings = async (updates) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/appearance/update`,
      updates,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== SEGURANÇA ====================

export const getActiveSessions = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/settings/security/sessions`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const endSession = async (sessionId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/settings/security/sessions/${sessionId}`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const endAllOtherSessions = async () => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/settings/security/sessions`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const toggleTwoFactor = async (enabled, method = null) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/security/two-factor`,
      { enabled, method },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const changePassword = async (currentPassword, newPassword, confirmPassword) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/security/password`,
      { currentPassword, newPassword, confirmPassword },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== CONTEÚDO ====================

export const updateContentSettings = async (updates) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/content/update`,
      updates,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== ACESSIBILIDADE ====================

export const updateAccessibilitySettings = async (updates) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/accessibility/update`,
      updates,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== BLOQUEIO E FILTROS ====================

export const getMutedItems = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/settings/blocking/muted`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addMutedItem = async (type, value) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/settings/blocking/muted`,
      { type, value },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const removeMutedItem = async (type, value) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/settings/blocking/muted`,
      {
        ...getConfig(),
        data: { type, value },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== FEED ====================

export const updateFeedSettings = async (updates) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/settings/feed/update`,
      updates,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== CONTA ====================

export const deactivateAccount = async (password, reason) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/settings/account/deactivate`,
      { password, reason },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteAccount = async (password, confirmation) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/settings/account/delete`,
      {
        ...getConfig(),
        data: { password, confirmation },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== BLOQUEIO DE USUÁRIOS ====================

export const getBlockedUsers = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/settings/blocking/users`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const blockUser = async (userIdToBlock) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/settings/blocking/users/block`,
      { userIdToBlock },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const unblockUser = async (userIdToUnblock) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/settings/blocking/users/unblock`,
      { userIdToUnblock },
      getConfig()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

const SettingsService = {
  getAllSettings,
  getSettings,
  updateSettings,
  resetSettings,
  updateNotificationSettings,
  updatePrivacySettings,
  requestDataDownload,
  updateAppearanceSettings,
  getActiveSessions,
  endSession,
  endAllOtherSessions,
  toggleTwoFactor,
  changePassword,
  updateContentSettings,
  updateAccessibilitySettings,
  getMutedItems,
  addMutedItem,
  removeMutedItem,
  updateFeedSettings,
  deactivateAccount,
  deleteAccount,
  getBlockedUsers,
  blockUser,
  unblockUser,
};

export default SettingsService;
